{
  "mandatoryFields": {
    "part1": "I campi preceduti da un",
    "part2": "sono obbligatori"
  },
  "confirm": {
    "leave": {
      "page": {
        "title": "Uscire dalla pagina?",
        "message": {
          "unsavedData": "Sono state effettuate delle modifiche che non saranno salvate. Uscire dalla pagina?"
        }
      }
    },
    "okLabel": "Conferma",
    "cancelLabel": "Annulla",
    "cancel": {
      "title": "Annullare le modifiche?",
      "message": "Sono state effettuate delle modifiche che non saranno salvate. Annullare le modifiche?"
    }
  },
  "noData": "Nessun dato"
}
